import $ from "jquery";
window.$ = window.jQuery = $;

import { createIcons, icons } from "lucide";
window.lucide = {
  icons,
  createIcons: (opts = {}) => createIcons({ icons, ...opts }),
};

import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;

// vendor js
import "simplebar";
import flatpickr from "flatpickr"
import flatpickrLocale from "flatpickr/dist/l10n/ko.js"
flatpickr.localize(flatpickrLocale.ko);
import Choices from "choices.js";
// 모듈 인라인 스크립트(select-search, 멤버 역할 멀티셀렉트 등)에서 new Choices() 를 쓸 수 있도록 전역 노출
window.Choices = Choices;
import "prismjs";
import Sortable from "sortablejs/modular/sortable.core.esm.js";
window.Sortable = Sortable;
import Inputmask from "inputmask";
// form.money 파셜 등 인라인 스크립트에서 통화/숫자 마스크로 사용 (INSPINIA form-other-plugins 와 동일 플러그인)
window.Inputmask = Inputmask;

// vendor css
import "flatpickr/dist/flatpickr.css";
import "choices.js/public/assets/styles/choices.css";
import "@tabler/icons-webfont/dist/tabler-icons.css";

// inspinia/scss
import "../scss/cms/default.scss";

// inspinia/app.js
import "../inspinia/js/app.js";
import "../inspinia/js/config.js";

// exms custom js
import "./plugins/popup.js";
import "./plugins/ui-notify.js";
import "./plugins/table.js";
import "./plugins/table-flow.js";
import "./plugins/pagination-scroll.js";
import "./plugins/calendar-mobile.js";
import "./plugins/delete.js";
import "./plugins/sortable.js";